// file: context/PortalContainerContext.tsx
"use client";

import React, {createContext, useContext} from "react";

const PortalContainerContext = createContext<HTMLElement | null>(null);

export const PortalContainerProvider = ({
  container,
  children,
}: {
  container: HTMLElement;
  children: React.ReactNode;
}) => (
  <PortalContainerContext.Provider value={container}>
    {children}
  </PortalContainerContext.Provider>
);

export const usePortalContainer = () => useContext(PortalContainerContext);
